export default "__VITE_ASSET__DcijFXCN__"